export default __webpack_public_path__ + "static/media/slider3.ff8b6246.png";